<template>
  <div class="MultipleQuoteGraphVue ipc-group-box ipc-city">
    <div class="title-city">
      <h2>{{ cityName }}</h2>
    </div>
    <div>
      <label class="ipc-ms-label">Sector</label>
      <multiselect
        v-model="selectedSector"
        :options="allSectors"
        select-label="ACTIVAR"
        deselect-label="DESACTIVAR"
        placeholder="Seleccionar por sector"
        @input="changeSector"
      >
        <template slot="noResult">
          <span v-html="'No se encontraron resultados.'"></span>
        </template>
      </multiselect>
    </div>
    <slot></slot>
    <ipc-graph :init-dataset="dataset" :init-params="params"></ipc-graph>
    <div class="btFuente"><strong>fuente:</strong><span>DANE</span></div>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import IpcGraph from "../ipc-graph/IpcGraph.vue";

export default {
  props: {
    dataset: Array,
    hRange: String,
    allSectors: Array,
    sector: String,
    city: String,
  },
  components: { Multiselect, IpcGraph },
  data() {
    return {
      params: {},
      selectedSector: null,
    };
  },
  created() {
    this.selectedSector = this.sector;
    this.params = {
      s: "period",
      cc: [this.city],
      ss: [this.sector],
      r: this.hRange,
    };
  },
  computed: {
    cityName() {
      return this.city == "Todas" ? "Nacional" : this.city;
    },
  },
  methods: {
    changeSector() {
      this.params.ss = [this.selectedSector];
    },
  },
};
</script>
